// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1quR9","sendOtp":"AuthorizeToLogin_sendOtp__UaYCY"};